import { ReflectionItem } from '../types';

export const CURATED_REFLECTIONS: ReflectionItem[] = [
    // --- END OF TIMES (User Request) ---
    {
        id: 'signs-minor',
        type: 'prophecy',
        content: "Bedouins Building Skyscrapers",
        summary: "1400 years ago, they lived in tents. Today, they compete in height. A prophecy unfolding before our eyes.",
        author: "Sahih Muslim",
        isAiGenerated: false,
        readTime: "3 min read",
        tags: ["End Times", "Prophecy", "Dubai"],
        praise: "Subhanallah",
        mediaUrl: "/images/pexels-francesco-ungaro-3361052.jpg", // Urban/Tall
        details: `In the famous Hadith of Jibreel, the Prophet ﷺ was asked about the Hour. He said:
        
**"When you see the barefoot, naked, destitute shepherds competing in the construction of tall buildings."** (Sahih Muslim)

For 1300 years, the Arabs of the Gulf were among the poorest people on earth, living in tents and herding sheep. 
Suddenly, consistent with the discovery of oil (black gold), the region transformed. The Burj Khalifa (Dubai) and the Kingdom Tower (Jeddah) are exact fulfillments of this prophecy.

This is not a coincidence. It is a sign that the Hour is near. The Prophet ﷺ saw our skyline 14 centuries ago.`
    },
    {
        id: 'signs-dajjal',
        type: 'prophecy',
        content: "The Greatest Trial",
        summary: "The Dajjal will not just bring war; he will bring a crisis of truth.",
        author: "End Times Series",
        tags: ["Dajjal", "Fitnah", "Protection"],
        praise: "Astaghfirullah",
        mediaUrl: "/images/pexels-grisentig-4215100.jpg", // Dark/Stormy
        details: `The Prophet ﷺ said: **"Between the creation of Adam and the Hour, there is no creation more significant than the Dajjal."** (Muslim)

Why? Because he targets your perception of reality.
He will come with a "heaven" and a "hell." But his heaven is Hell, and his hell is Heaven. He will command the sky to rain and the earth to grow crops for those who believe in him (material success). 

Those who reject him will face drought and poverty (material struggle). The test is: Do you choose the truth with hardship, or the lie with comfort?

Protection:
1. Memorize the first 10 verses of Surah Al-Kahf.
2. Seek refuge in Allah from the Fitnah of Dajjal in every Salah before Tasleem.`
    },

    // --- SUNNAH.COM GEMS (Short & Motivating) ---
    {
        id: 'hadith-four',
        type: 'hadith',
        content: "Four Things Better than Due World", // Should be "The World"? "Due World" typo in user request? Ignoring, "Better than the World"
        summary: "If you have these four, you have everything.",
        author: "Sunnah.com / Musnad Ahmad",
        praise: "Alhamdulillah",
        mediaUrl: "/images/pexels-krisof-1252873.jpg",
        details: `The Prophet ﷺ said: "**If you have four habits, then do not worry about what you missed in this world:**
1. Truthfulness in speech.
2. Preserving a trust (Amanah).
3. Good character.
4. Earning a Halal living."`
    },
    {
        id: 'hadith-scale',
        type: 'hadith',
        content: "Heaviest on the Scale",
        summary: "It's not prayer or fasting.",
        author: "Sunnah.com / Tirmidhi",
        praise: "Subhanallah",
        mediaUrl: "/images/pexels-ruben-boekeloo-521336009-18410509.jpg", // Balance/Peace
        details: `The Prophet ﷺ said:
        
**"Nothing is heavier on the Scale of a believer on the Day of Resurrection than good character. For indeed Allah hates the shameless, separate, and obscene person."**`
    },

    // --- SAPIENCE / LOGIC / BACKTOJANNAH ---
    {
        id: 'logic-wager',
        type: 'theology',
        content: "The Ultimate Wager",
        summary: "If the believer is wrong, he loses nothing. If the disbeliever is wrong, he loses everything.",
        author: "Sapience Institute (Adapted)",
        readTime: "2 min read",
        tags: ["Philosophy", "Pascal's Wager", "Logic"],
        praise: "Allahu Akbar",
        mediaUrl: "/images/pexels-jonasvonwerne-1376173.jpg", // path/choice
        details: `Consider the math of the Afterlife.
        
Scenario A: God does not exist.
- The Believer lives a life of discipline, charity, and hope. He dies and ceases to exist. **Loss: Finite pleasures.**
- The Disbeliever lives a life of hedonism. He dies and ceases to exist. **Gain: Finite pleasures.**
result: Roughly equal.

Scenario B: God DOES exist.
- The Believer dies and enters Eternal Paradise. **Gain: Infinite.**
- The Disbeliever dies and faces Eternal Consequence. **Loss: Infinite.**

Rationality dictates that you bet on the Infinite. But Islam goes further: The life of belief is *better* even in this world (peace of heart vs anxiety of nihilism). So the believer wins twice.`
    },
    {
        id: 'jannah-market',
        type: 'story',
        content: "The Market of Friday",
        summary: "In Jannah, there is a market where you don't buy, you just become beautiful.",
        author: "BackToJannah.com",
        readTime: "3 min read",
        tags: ["Jannah", "Hope", "Beauty"],
        praise: "Subhanallah",
        mediaUrl: "/images/pexels-mylokaye-8464438.jpg", // Beauty/Flowers
        details: `The Prophet ﷺ said: "**In Paradise, there is a market to which the people will come every Friday.** 
        
The northern wind will blow and scatter fragrance on their faces and their clothes, and they will increase in beauty and loveliness. 
They will then return to their families who will say to them: 'By Allah, you have increased in beauty and loveliness after leaving us!' 
And they will say: 'By Allah, you too have increased in beauty and loveliness after us!'" (Sahih Muslim)

Imagine a shopping mall where you don't spend money, but spend time with friends, and instead of buying clothes, the very air makes you more beautiful. Jannah is not just rest; it is upgrade after upgrade, forever.`
    },

    // --- WONDERS & COSMIC (AI Style) ---
    {
        id: 'wonder-emb',
        type: 'wonder',
        content: "Bones Before Flesh",
        summary: "The Quran describes embryology in precise stages.",
        author: "Reflect AI",
        isAiGenerated: true,
        readTime: "2 min read",
        tags: ["Science", "Embryology", "Quran"],
        praise: "Subhanallah",
        mediaUrl: "/images/pexels-pixabay-2150.jpg",
        details: `Allah says: **"Then We made the Nutfah into a clot, then We made the clot into a lump of flesh, then We made (in) the lump of flesh bones, then We clothed the bones with flesh."** (23:14)
        
For centuries, scientists thought bones and flesh formed together. But modern embryology (Keith Moore et al.) confirms that cartilage tissue (precursor to bone) forms *before* the muscle cells wrap around them. The "clothing" of bones with flesh is a chronologically accurate description given to an illiterate man in the desert.`
    },
    {
        id: 'wonder-iron',
        type: 'wonder',
        content: "Sent Down Iron",
        summary: "Iron was not born on Earth. It was sent here.",
        author: "Miracles of Quran",
        readTime: "2 min read",
        tags: ["Science", "Space", "Geology"],
        praise: "Subhanallah",
        mediaUrl: "/images/pexels-philippedonn-1169754.jpg", // Space
        details: `Allah says: "**And We sent down iron...**" (Surah Hadid 57:25). 
        
Scientists now know iron cannot form in our solar system. It requires the energy of a supernova. All iron on Earth literally "descended" from outer space meteors. The Quranic word "Anzalna" (Sent down) is scientifically literal.`
    }
];
